<template>
  <m-dialog ref="dlg" @save="save">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="10" lg="7" xl="7">
        <v-row>
          <v-card tile flat>
            <v-card-text>
              <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                <v-row wrap>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-row wrap>
                      <v-col class="text-left title" cols="12" align-start colbox> Unggah Dokumen</v-col>

                      <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                        <p class="font-weight-bold" v-if="edit && dokumen.berkas">
                          Berkas :
                          <a :href="dokumen.berkas.file.origin" target="_blank">
                            {{ pVal(dokumen, "keterangan") }}
                          </a>
                        </p>
                        <v-file-input
                          ref="file"
                          v-model="file"
                          persistent-hint
                          id="file"
                          :placeholder="edit ? 'Ubah Berkas' : 'Pilih Berkas'"
                          name="File"
                          data-vv-name="file"
                          data-vv-as="Berkas"
                          v-validate="edit ? '' : 'required'"
                          :error-messages="errors.collect('form.file')"
                          outlined
                          dense
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {
  components: {},
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      rend: 1,
      file: null,
      jabatan: {},
      accepts: ["application/pdf"].join(","),
      search: null,
      kode: {
        wilayah_id: null,
        tingkat: null
      },
      edit: false,
      dokumen: {},

      defUser: {
        name: null,
        foto: null,
        ktp: null,
        email: "",
        no_hp: null,
        kelamin: "L"
      },
      itemJabatans: [],
      itemKandidats: []
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj, wilayah, tingkat, isEdit) {
      this.edit = isEdit == "ubah" ? true : false;

      this.dokumen = obj;
      if (obj) {
        this.dokumen.dokumen_id = obj.id;
      }
      this.kode.wilayah = wilayah;
      this.kode.tingkat = tingkat;
      this.rend = this.rend + 1;
      this.$validator.reset();

      return this.$refs.dlg.open();
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.dokumen.wilayah_id = this.kode.wilayah;
          this.dokumen.tingkat = this.kode.tingkat;
          this.dokumen.file = this.file;
          return this.$store.dispatch("dokumen/form", this.dokumen);
        })
        .then(res => {
          if (res.error) {
            this.$error("Berkas gagal diperbarui");
          } else {
            this.$info("Berkas berhasil ditambahkan");
            this.$refs.dlg.resolve();
            return res;
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    "dokumen.propinsi_id": function(n) {
      this.getKota(n);
    },
    "dokumen.kota_id": function(m) {
      this.getKecamatan(m);
    },
    "dokumen.kecamatan_id": function(o) {
      this.getKelurahan(o);
    },
    selectedDate(n) {
      if (n) var dateFormat = n.split(".");
      this.dokumen.tanggal_lahir = dateFormat[2] + "-" + dateFormat[1] + "-" + dateFormat[0];
    }
  }
};
</script>

<style>
.avatar-cropper-close {
  display: none;
}
</style>
